import React, { Component } from 'react'
import { t } from 'i18next'

export default class Filters extends Component {
  render() {
    const { activeFilters, updateFilter } = this.props

    return (
      <div className="filters">
        <h3>Filters</h3>

        <div className="fields">

          <div className="field">
            <h4>{t('style')}</h4>
            <div className="options">
              <div onClick={() => updateFilter('style', 'modern')}
                className={activeFilters.style === 'modern' ? 'active' : ''}>{t('modern')}</div>
              <div onClick={() => updateFilter('style', 'traditional')}
                className={activeFilters.style === 'traditional' ? 'active' : ''}>{t('traditional')}</div>
            </div>
          </div>

          <div className="field">
            <h4>{t('houses.levels')}</h4>
            <div className="options">
              <div onClick={() => updateFilter('levels', '1')}
                className={activeFilters.levels === '1' ? 'active' : ''}>1</div>
              <div onClick={() => updateFilter('levels', '2')}
                className={activeFilters.levels === '2' ? 'active' : ''}>2</div>
              <div onClick={() => updateFilter('levels', '3')}
                className={activeFilters.levels === '3' ? 'active' : ''}>3</div>
            </div>
          </div>

          <div className="field">
            <h4>{t('houses.usable_area')} (in m²)</h4>
            <div className="options">
              <input onChange={e => updateFilter('usable_area_from', e.target.value)} type="number" />
              <input onChange={e => updateFilter('usable_area_to', e.target.value)} type="number" />
            </div>
          </div>

          <div className="field">
            <h4>{t('houses.building_area')} (in m²)</h4>
            <div className="options">
              <input onChange={e => updateFilter('building_area_from', e.target.value)} type="number" />
              <input onChange={e => updateFilter('building_area_to', e.target.value)} type="number" />
            </div>
          </div>

          <div className="field">
            <h4>{t('houses.roof_area')} (in m²)</h4>
            <div className="options">
              <input onChange={e => updateFilter('roof_area_from', e.target.value)} type="number" />
              <input onChange={e => updateFilter('roof_area_to', e.target.value)} type="number" />
            </div>
          </div>

          <div className="field">
            <h4>{t('houses.roof_slope')} (in °)</h4>
            <div className="options">
              <input onChange={e => updateFilter('roof_slope_from', e.target.value)} type="number" />
              <input onChange={e => updateFilter('roof_slope_to', e.target.value)} type="number" />
            </div>
          </div>

        </div>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Houses/filters.js